import React ,{useState,useEffect} from 'react';

import ArticleForm from '../../componenents/Forms/ArticleForm';
import BackButton from '../../componenents/Buttons/BackButton';
import { fetchCategoriesService, fetchSubCategoriesService } from '../../services/CategoryService';
import { Button, Typography, Row, Col } from 'antd';

import '../../styles/CreateArticle.css';

const { Title } = Typography;
const CreateArticlePage = () => {

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false); // Loading state

  useEffect(() => {
    // Fetch categories from the article service
    const auth = localStorage.getItem('authToken')!=null ? true :false;
    setAuth(auth);
    console.log(auth);
    const loadCategories = async () => {
      try {
        const fetchedCategories = await fetchCategoriesService(); // Fetch categories from the service
        setCategories(fetchedCategories); // Set the categories
        const fetchedSubCategories = await fetchSubCategoriesService(); // Fetch categories from the service
        setSubCategories(fetchedSubCategories); // Set the categories
       // console.log(subcategories);
      } catch (error) {
        console.error('Failed to load categories', error); // Handle any errors
      } finally {
        setLoading(false); // Stop loading after fetching the categories
      }
    };

    loadCategories();
  }, []);
  return (
    <div className="create-article-container">
      <Row justify="center">
        <Col xs={24} md={20} lg={16}>
          {/* Back Button */}
          <div className="back-button">
            <BackButton />
          </div>

          {/* Title */}
          <Title level={2} style={{ marginBottom: '30px', textAlign: 'center' }}>
            Create New Article
          </Title>

          {/* Article Form */}
          <div className="article-form-wrapper">
            <ArticleForm categories={categories} subCategories={subcategories} />
          </div>
        </Col>
      </Row>
    </div>
  );

};

export default CreateArticlePage;
